import { render } from "./ModalMainDisplay.vue?vue&type=template&id=1ca425a4&scoped=true"
import script from "./ModalMainDisplay.vue?vue&type=script&lang=js"
export * from "./ModalMainDisplay.vue?vue&type=script&lang=js"

import "./ModalMainDisplay.vue?vue&type=style&index=0&id=1ca425a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ca425a4"

export default script